import { render, staticRenderFns } from "./OfficialRoomManage.vue?vue&type=template&id=34e77188&scoped=true"
import script from "./OfficialRoomManage.vue?vue&type=script&lang=js"
export * from "./OfficialRoomManage.vue?vue&type=script&lang=js"
import style0 from "./OfficialRoomManage.vue?vue&type=style&index=0&id=34e77188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e77188",
  null
  
)

export default component.exports